import { RegionsService } from '@/backend/auth'
import { RegionRepository } from '../../domain/repositories/RegionRepository'
import { RegionMiniModel } from '../models/RegionMiniModel'
import type { RegionFilterEntity } from '../../domain/entities/RegionFilterEntity'
import type { RegionMiniEntity } from '../../domain/entities/RegionMiniEntity'
import type { RegionEntity } from '../../domain/entities/RegionEntity'
import { RegionModel } from '../models/RegionModel'
import { Language } from '@/shared/enums/languagesEnum'

export class RegionRepositoryImpl implements RegionRepository {
  async getRegions(filterData: RegionFilterEntity): Promise<RegionMiniModel[] | 'error'> {
    try {
      const response = await RegionsService.getRegionsAdmin(filterData)

      if (!response.regions) {
        return []
      }

      const regionMiniModels = response.regions.map((dto) => new RegionMiniModel(dto))
      return regionMiniModels
    } catch {
      return 'error'
    }
  }
  async getMiniRegion(id: number): Promise<RegionMiniEntity | { error: true }> {
    try {
      const response = await RegionsService.getRegionAdmin({
        id
      })
      const regionModel = new RegionModel(response as RegionEntity)

      return {
        id: regionModel.id,
        name: regionModel.translations
          ? (regionModel.translations.find((translation) => translation.language === Language.EN)
              ?.name ?? '')
          : ''
      }
    } catch {
      return { error: true }
    }
  }
  async getRegion(id: number): Promise<RegionEntity | { error: true }> {
    try {
      const response = await RegionsService.getRegionAdmin({
        id
      })
      const regionModel = new RegionModel(response as RegionEntity)

      return regionModel
    } catch {
      return { error: true }
    }
  }
}
